import { Alert } from '@design-system';
import { Trans, useTranslation } from 'next-i18next';
import { FC } from 'react';

import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';

interface Props {
  onClick: () => void;
}

export const AddCustomsCodeButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation('product');
  const drawController = usePreAuthDrawCtx();

  const address = (drawController.addresses || []).find(
    ({ id }) => id === drawController.selectedAddress,
  );

  if (!address || !drawController.customsCodeIsRequired) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <Alert status="error">
        <Trans i18nKey="drawers.review.customs.buttonText" t={t}>
          In order to ship to {address.countryName}, please
          <button className="hyperlink" onClick={onClick} type="button">
            add customs details
          </button>
          .
        </Trans>
      </Alert>
    </div>
  );
};
